import script from "./Head.vue?vue&type=script&setup=true&lang=js"
export * from "./Head.vue?vue&type=script&setup=true&lang=js"

import "./Head.vue?vue&type=style&index=0&id=448b5d5b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\33\\Desktop\\2024\\block-explorer-ts\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-448b5d5b"]])

export default __exports__